import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {PAY} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'
import {orderSheetUrlSelector} from '@web/slices/common/slice'

import {NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

const PAY_LATER_HOME_URL = `${PAY}/paylater`

/**
 * 후불결제 홈으로 이동
 */
const navigateToPayLaterHome = createAsyncThunk<
    Promise<string | unknown>,
    NavigationTypeSelectableParam | void,
    ThunkApi
>('navigateTo/payLaterHome', async (args, {getState}) => {
    const {forceLocationChange = false} = args ?? {}
    const state = getState()

    const shouldChangeLocation = forceLocationChange || isMobile

    if (shouldChangeLocation) {
        const orderSheetUrl = orderSheetUrlSelector(state)
        const url = qs.stringifyUrl({url: PAY_LATER_HOME_URL, query: {rurl: orderSheetUrl}})

        changeBrowserLocation({url, type: 'PUSH'})
        // page 이동 시행시에는 그 자체로 resolve
        return Promise.resolve()
    }

    openNewTab({url: PAY_LATER_HOME_URL})

    // new tab에서 응답 받아오지 않으므로 resolve
    return Promise.resolve()
})

export default navigateToPayLaterHome
